module.exports = __webpack_public_path__ + "static/estate-5bd60259c19425ad15183deaa198f3fa.jpg";